/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HybridInputs */

const en_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybrid`)
};

const th_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไฮบริด`)
};

const ja_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイブリッド`)
};

const fr_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hybride`)
};

const es_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Híbrida`)
};

const ru_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гибрид`)
};

const zh_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`杂交`)
};

const vi_hybrid = /** @type {(inputs: HybridInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lai`)
};

/**
* | output |
* | --- |
* | "Hybrid" |
*
* @param {HybridInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const hybrid = /** @type {((inputs?: HybridInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HybridInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_hybrid(inputs)
	if (locale === "ja") return ja_hybrid(inputs)
	if (locale === "fr") return fr_hybrid(inputs)
	if (locale === "es") return es_hybrid(inputs)
	if (locale === "ru") return ru_hybrid(inputs)
	if (locale === "zh") return zh_hybrid(inputs)
	if (locale === "vi") return vi_hybrid(inputs)
	return en_hybrid(inputs)
});